// removed by extract-text-webpack-plugin
module.exports = {"sectionSkeleton":"styles__sectionSkeleton___1xuLc","skeletonTitle":"styles__skeletonTitle___3zjR5","cardSkeleton":"styles__cardSkeleton___2kTK8","skeletonText":"styles__skeletonText___jU8uS","skeleton":"styles__skeleton___1DCFX","skeleton-loading":"styles__skeleton-loading___smQvR","skeletonGreen":"styles__skeletonGreen___3EWmu","skeleton-loading-green":"styles__skeleton-loading-green___125Et"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/TrafficPreControleSkeleton/styles.css
// module id = 2522
// module chunks = 0